<template>
  <div>
    <Pos_debt_balance_pay_bank/>
  </div>
</template>

<script>
import Pos_debt_balance_pay_bank from "@/components/adminArin/pos_system/product/Pos_debt_balance_pay_bank";
export default {
  name: "PosDebtBalancePayBank",
  components: {
    Pos_debt_balance_pay_bank
  }
}
</script>

<style scoped>

</style>
